var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.002 0.75C26.5304 0.75 27.7723 1.98686 27.7725 3.50977C27.7725 3.84282 27.6041 4.48587 27.2715 5.36133C26.9523 6.20146 26.5217 7.15594 26.0859 8.06152C25.7009 8.86168 25.3133 9.61473 25.0029 10.207C24.6933 9.61393 24.3078 8.85944 23.9238 8.05859C23.4893 7.15249 23.0605 6.19812 22.7422 5.3584C22.4103 4.48281 22.2422 3.84052 22.2422 3.50977C22.2423 1.98417 23.4764 0.750127 25.002 0.75Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0664 20.124C41.993 23.2398 41.9863 26.5189 41.0566 29.6445L32.0918 25.9297C32.1945 25.2363 32.1946 24.5332 32.0918 23.8398L41.0664 20.124Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9922 10.1689C35.855 11.7197 38.1786 14.0359 39.7305 16.8887L30.7559 20.6035C30.3373 20.0412 29.8395 19.5477 29.2773 19.1328L32.9922 10.1689Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4336 22.4014V22.4023L17.9111 23.8477C17.8082 24.5392 17.8085 25.2382 17.9111 25.9297L8.94531 29.6455C8.01733 26.5283 8.01856 23.2492 8.9541 20.1328L14.4336 22.4014Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9081 26.5798C21.3581 27.6698 22.2081 28.5098 23.2981 28.9698C24.3881 29.4198 25.5881 29.4198 26.6781 28.9698C27.7681 28.5198 28.6181 27.6698 29.0681 26.5798C29.5181 25.4798 29.5281 24.2798 29.0681 23.1998C28.6181 22.1098 27.7681 21.2598 26.6781 20.8098C25.5881 20.3598 24.3881 20.3498 23.2981 20.7998C22.2081 21.2598 21.3681 22.1098 20.9081 23.1998C20.4681 24.2898 20.4681 25.4898 20.9081 26.5798ZM25.0081 21.8898C26.6581 21.8898 28.0081 23.2298 28.0081 24.8898C28.0081 26.5398 26.6581 27.8898 25.0081 27.8898C23.3481 27.8898 22.0081 26.5398 22.0081 24.8898C22.0081 23.2298 23.3481 21.8898 25.0081 21.8898Z",
    fill: "#FBCC4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7568 8.8335L27.6094 14.0122V14.0132L26.042 17.7993C25.7794 17.7606 25.5145 17.7365 25.249 17.7271L25.6777 16.8208L27.4307 13.1099C27.9752 12.1286 28.8459 10.4901 29.6172 8.79346C29.6637 8.80666 29.7103 8.81973 29.7568 8.8335ZM20.3984 8.78955C21.1703 10.4849 22.0481 12.1272 22.5918 13.1069L24.3203 16.8169L24.7441 17.7271C24.4822 17.7363 24.2209 17.7596 23.9609 17.7983L20.2451 8.8335C20.2961 8.81828 20.3474 8.80425 20.3984 8.78955Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.8901C25.5523 25.8901 26 25.4424 26 24.8901C26 24.3379 25.5523 23.8901 25 23.8901C24.4477 23.8901 24 24.3379 24 24.8901C24 25.4424 24.4477 25.8901 25 25.8901Z",
    fill: "#FBCC4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7129 32.8716C38.1688 35.7331 35.8471 38.0566 32.9932 39.6011L31.2041 35.2827L29.2764 30.6353C29.8392 30.2165 30.3328 29.7183 30.748 29.1558L39.7129 32.8716Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7773 14.4463V14.4473L20.7139 19.124C20.1512 19.5428 19.6573 20.041 19.2422 20.6035L12.1768 17.6768L10.2891 16.8896C11.84 14.0345 14.1561 11.7118 17.0078 10.168L18.7773 14.4463Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7559 40.9453C26.6484 41.8723 23.3723 41.8724 20.2568 40.9453L20.2725 40.9092L20.2734 40.9062L23.96 31.9795C24.6509 32.0821 25.3491 32.0821 26.04 31.9795L29.7559 40.9453Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2461 29.1748C19.6646 29.7374 20.1624 30.2313 20.7246 30.6465L20.0889 32.1826V32.1836L17.0195 39.6006C14.1494 38.0499 11.8255 35.7351 10.2812 32.8906L14.5996 31.1025L19.2461 29.1748Z",
    stroke: "#FBCC4C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.26202d24bad676140cbdb0304678ac4a.svg";
export { ForwardRef as ReactComponent };